import { useLanguage } from '@i18n/useLanguage'
import Column from '@app/components/layout/Column'
import { i18n } from '@i18n/index'
import { TextLink } from '@app/components/core/link/TextLink'
import { MegaMenuLinks } from '../blocks/common'
import { MegaMenuMobileItem } from '../blocks/MegaMenuMobileItem'
import {
  faUsers,
  faScaleBalanced,
  faHandshake,
} from '@fortawesome/pro-solid-svg-icons'
import { Style } from 'inlines'

const textLinkStyle: Style = { textDecoration: 'none' }

export const AboutUsMenu = () => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.nav.megaMenu.aboutUsMenu
  return (
    <Column gap="1rem" style={{ alignSelf: 'stretch', flexGrow: 1 }}>
      <MegaMenuMobileItem
        to={MegaMenuLinks.aboutUs}
        icon={faUsers}
        label={translations.about.label}
        description={translations.about.description}
        backgroundColor="var(--brand-tertiary)"
      >
        <TextLink
          to={MegaMenuLinks.stewardOwnership}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.about.links.stewardOwned}
        </TextLink>
        <TextLink
          externalURL
          target="_blank"
          to={MegaMenuLinks.joinUs}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.about.links.joinUs}
        </TextLink>
        <TextLink
          to={MegaMenuLinks.contactUs}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.about.links.contact}
        </TextLink>
      </MegaMenuMobileItem>
      <MegaMenuMobileItem
        to={MegaMenuLinks.legal}
        icon={faScaleBalanced}
        label={translations.legal.label}
        description={translations.legal.description}
        backgroundColor="var(--palette-yellow-300)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.aboutUs}
        icon={faHandshake}
        label={translations.partner.label}
        backgroundColor="var(--palette-pink-200)"
      >
        <TextLink
          to={MegaMenuLinks.municipalities}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.partner.links.municipalities}
        </TextLink>
        <TextLink
          to={MegaMenuLinks.experts}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.partner.links.experts}
        </TextLink>
      </MegaMenuMobileItem>
    </Column>
  )
}
